module.exports = __webpack_public_path__ + "img/spear-achille.21c0ba0a.jpg";